import type { Membro, Usuario } from "@escalando/contracts";
import { StrictMode, useCallback, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { api, auth, definirAoExpirar } from "./api";
import { Carregando } from "./comum";
import "./estilo.css";
import { Pessoas, Worker } from "./telas/Admin";
import { Login } from "./telas/Login";
import { Tarefa } from "./telas/Tarefa";
import { Inicio, Tarefas } from "./telas/Tarefas";
import "./tokens.css";

type Eu = { usuario: Usuario; projetos: Membro[] };

const useRota = () => {
  const [rota, setRota] = useState(location.hash.slice(1) || "/");
  useEffect(() => {
    const f = () => setRota(location.hash.slice(1) || "/");
    addEventListener("hashchange", f);
    return () => removeEventListener("hashchange", f);
  }, []);
  return rota;
};

function App() {
  const [eu, setEu] = useState<Eu | null>();
  const rota = useRota();
  const carregar = useCallback(() => {
    api<Eu>("GET", "eu").then(setEu, () => setEu(null));
  }, []);
  useEffect(() => {
    definirAoExpirar(() => setEu(null));
    // Tenta retomar a sessão pelo cookie (válida até 24 h desde o login com MFA).
    auth.renovar().then(carregar, () => setEu(null));
  }, [carregar]);

  if (eu === undefined) return <div className="casco"><Carregando /></div>;
  if (eu === null) return <Login aoEntrar={carregar} />;

  const levy = eu.usuario.admin_global;
  const [, secao, id] = rota.split("/");
  const tela = (() => {
    switch (secao) {
      case "tarefas": return <Tarefas />;
      case "tarefa": return <Tarefa id={id ?? ""} />;
      case "worker": return levy ? <Worker /> : null;
      case "pessoas": return levy ? <Pessoas /> : null;
      default: return <Inicio />;
    }
  })();
  const item = (href: string, nome: string, s: string | undefined) => (
    <a href={href} className={(secao ?? "") === (s ?? "") ? "ativo" : ""}>{nome}</a>
  );
  return (
    <>
      <header className="topo">
        <span className="marca">Escalando IA</span>
        <span className="linha">
          <span className="suave">{eu.usuario.nome}</span>
          <button onClick={() => void auth.sair().then(() => setEu(null))}>Sair</button>
        </span>
      </header>
      <main className="casco">{tela}</main>
      <nav className="menu">
        {item("#/", "Início", "")}
        {item("#/tarefas", "Tarefas", "tarefas")}
        {levy && item("#/worker", "Worker", "worker")}
        {levy && item("#/pessoas", "Pessoas", "pessoas")}
      </nav>
    </>
  );
}

if ("serviceWorker" in navigator && import.meta.env.PROD) void navigator.serviceWorker.register("/sw.js");
createRoot(document.getElementById("raiz") as HTMLElement).render(<StrictMode><App /></StrictMode>);
